import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import Heading from "shared/ui/typography/Heading";
import { doorUsps } from "shared/utils/usps";
import { USPHeaderList } from "../usp-header-list";
import { zakelijkDoorCodes } from "features/option-controls/door-width-controls/ZakelijkHelper";

export const DoorOptionsUSPHeader = () => {
  const { selectedDoor, selfAssembleDoorData } =
    useConfigurationOptionsContext();

  if (!selectedDoor || !doorUsps[selectedDoor.code]) return null;

  // Gather the USP list
  const uspList =
    !selfAssembleDoorData.selfAssembly ||
    zakelijkDoorCodes.includes(selectedDoor.code)
      ? doorUsps[selectedDoor.code]
      : doorUsps["selfAssembly"];

  return (
    <header className="gg-px-7 gg-pb-4 gg-pt-4 lg:gg-pb-5 lg:gg-pt-6">
      <Heading
        headingLevel="h2"
        className="gg-font-bold gg-leading-6 gg-text-slate-800 md:gg-leading-8 lg:gg-text-2xl"
      >
        {selectedDoor.name}
      </Heading>

      <USPHeaderList uspList={uspList} />
    </header>
  );
};
